const TurnTurnTurn = [
	'[CHORUS]',
	'To everything,(turn, turn, turn)',
	'there is a season;(turn, turn, turn)',
	'and a time to every purpose, under heaven',
	'',
	'[VERSE 1]',
	'A time to be born, a time to die',
	'A time to plant, a time to reap',
	'A time to kill, a time to heal',
	'A time to laugh, a time to weep',
	'',
	'[CHORUS]',
	'To everything,(turn, turn, turn)',
	'there is a season;(turn, turn, turn)',
	'and a time to every purpose, under heaven',
	'',
	'[VERSE 2]',
	'A time to build up, a time to break down',
	'A time to dance, a time to mourn',
	'A time to cast away stones,',
	'a time to gather stones together',
	'',
	'[CHORUS]',
	'To everything,(turn, turn, turn)',
	'there is a season;(turn, turn, turn)',
	'and a time to every purpose, under heaven',
	'',
	'[VERSE 3]',
	'A time of love, a time of hate',
	'A time of war, a time of peace',
	'A time you may embrace,',
	'a time to refrain from embracing',
	'',
	'[CHORUS]',
	'To everything,(turn, turn, turn)',
	'there is a season;(turn, turn, turn)',
	'and a time to every purpose, under heaven',
	'',
	'[VERSE 4]',
	'A time to gain, a time to lose',
	'A time to rend, a time to sew',
	'A time for love, a time to hate',
	'A time for peace,',
	"I swear it's not too late",
];

export default TurnTurnTurn;
